export default {
      id: "picto-quote-bottom-usage",
      viewBox: "0 0 60 49",
      url: "../dist/images/" + "sprite.svg#picto-quote-bottom-usage",
      toString: function () {
        return this.url;
      }
    }